import { render, staticRenderFns } from "./PantallaH.vue?vue&type=template&id=cbd58af4&scoped=true"
import script from "./PantallaH.vue?vue&type=script&lang=js"
export * from "./PantallaH.vue?vue&type=script&lang=js"
import style0 from "./PantallaH.vue?vue&type=style&index=0&id=cbd58af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd58af4",
  null
  
)

export default component.exports